export const sidebarConfig = {
  dimensions: {
    collapsed: 16 * 2 + 40,
    open: 240,
  },
  durations: {
    expand: 200,
    itemsVisibility: 100,
  },
};
